import View from "../nav/views/ProductSummaryTrimHeightView";
import components from "./components.js";
components.define("js-productSummaryTrimHeight", View);